import React, { useMemo, useEffect, useState, useContext, useRef } from "react";
import { Alert, Box, Button, Stack, Typography } from "@mui/material";
import stylesService from "../../styles/Molecules/ReportesServicio/service";
import { Link } from "react-router-dom";
import useWexClient from "../../hooks/Clients/wexClient,";
import { useCabin } from "../../hooks/useCabin";
import { usePermissions } from "../../hooks/usePermissions";

import { socketWex } from "../../utils/Socket";
import { AuthContext } from "../../Auth/Context";
import { useNotificationSound } from "../../hooks/useNotificationsSound";
import { useTranslation } from "react-i18next";
import "../../Traduccion_ES_EN/i18nMiCuenta";
import InputLabel from "../atoms/InputLabel";
import MuiModal from "../atoms/MuiModal";
import Calendario from "../../components/atoms/Calendario";
import AutoCompleteComponent from "../atoms/AutoCompleteComponent";
import ButtonComponent from "../atoms/ButtonComponent";
import SelectComponent from "../atoms/Select";
import { startOfDay, format } from "date-fns";
import stylesAgent from "../../styles/Molecules/Agents/styleAgents";
import ChatCabin from "./ChatCabin";
import CabinTables from "./CabinTables";
import CabinFormModal from "./CabinFormModal";

function MapsReports({
  userId = "",
  endDate = null,
  setEndDate = () => {},
  startDate = null,
  setStartDate = () => {},
  selectedAgent = null,
  setSelectedAgent = () => {},
  selectedList = null,
  setSelectedList = () => {},
  setTypeReport = () => {},
  setServiceProp = () => {},
  typeReport = "",
  serviceProp = "",
  setUsers = () => {},
  users = [],
  nameAgent = [],
  setNameAgent = [],
  permissions,
  incidentCreatedMeta = null,
  incidentLocation = null,
}) {
  const { t } = useTranslation();
  const { payload } = useContext(AuthContext);
  const [selectAgents, setSelectAgents] = useState([]);
  const idSupervisor = payload._id;
  //permisos
  const { can } = usePermissions(payload);

  //
  const canCancel = permissions?.incidents?.cancel?.enabled;
  const requirePin = permissions?.incidents?.cancel?.requirePin;
  const canCreateIncident = permissions?.incidents?.create;
  const canReassignIncident = permissions?.incidents?.reassign;
  //selects
  const {
    locationAgents,
    usersForRegion,
    locationForAgent,
    getAvailableAgents,
    //getIncidentsForHeatmap,
    //getIncidentsMapReport,

    createForms,
    sendWhatsApp, // enviamos mj via whats
    sendMessageCabin, // enviamos mensaje
    getContactsCabin, //obtenemos chats
    getConversationCabin, // obtenemos historial de 1 chat
    getWhatsAppWindow, // para ver si esta activo
  } = useWexClient();

 


  const {
    routesData,
    pendingData,
    fetchCabinData,
  } = useCabin();

  const { playSound, stopSound } = useNotificationSound();

  const [formState, setFormState] = useState(null);

  const [selectList, setSelectList] = useState([]); //selects
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [initialData, setInitialData] = useState(null);

  const [showAlert, setShowAlert] = useState(false);
  const [messageAlert, setMessageAlert] = useState("");
  const [showAlertError, setShowAlertError] = useState(false);
  const [messageAlertError, setMessageAlertError] = useState("");
  const [idAgent, setIdAgent] = useState("");
  const [typeAlert, setTypeAlert] = useState("success");
  const [adjusters, setAdjusters] = useState([]);
  const [typeAlertError, setTypeAlertError] = useState("error");
  const DEFAULT_AGENT = "00001";

  const [chatCabin, setChatCabin] = useState(false);
  const [openAcceptModal, setOpenAcceptModal] = useState(false);
  const [openFinishModal, setOpenFinishModal] = useState(false);
  const [openRejectModal, setOpenRejectModal] = useState(false);
  const [openTimeOutModal, setOpenTimeOutModal] = useState(false);

  const [chats, setChats] = useState([]);
  const [conversations, setConversations] = useState({});
  const [messageValue, setMessageValue] = useState("");
  const [activeChatId, setActiveChatId] = useState(null);
  const alertContainerRef = useRef(null);
  const activeFolio =
    activeChatId && conversations[activeChatId]
      ? (conversations[activeChatId].idFolioBodie ?? "none")
      : "none";
  // DATOS PARA NOTIFICIONES
  const [adjusterName, setAdjusterName] = useState("");
  const [adjusterUser, setAdjusterUser] = useState("");
  //TABLAS DE PENDIENTES Y AJUSTADORES EN RUTA
  const [localRoutes, setLocalRoutes] = useState([]);
  const [localPending, setLocalPending] = useState([]);

  const [folioClassification, setFolioClassification] = useState("");
  const [reportType] = useState([
    {
      _id: "1",
      name: "Real-time",
      value: "real-time",
    },
    {
      _id: "2",
      name: "Rutas",
      value: "route",
    },
    {
      _id: "3",
      name: "Check-In",
      value: "check-in",
    },
    /*{
      _id: "4",
      name: "HeatMap",
      value: "heatmap",
    },*/
  ]);

  const chatsRef = React.useRef(chats);

  useEffect(() => {
    chatsRef.current = chats;
  }, [chats]);

  useEffect(() => {
    if (routesData.length && localRoutes.length === 0) {
      setLocalRoutes(routesData);
    }
    if (pendingData.length && localPending.length === 0) {
      setLocalPending(pendingData);
    }
  }, [routesData, pendingData]);

  const [selectedOptionRep, setSelectedOptionRep] = useState(() => {
    if (reportType.length > 0) {
      return reportType[0]?._id;
    }
    return null;
  });

  //✅ VALIDAR Y OBTENER KEY ÚNICA PARA DEDUPLICACIÓN
  const getUniquePendingKey = (incident) => {
    return (
      incident?.header?.externalFolio ||
      incident?.externalFolio ||
      incident?.data?.[2] ||
      null
    );
  };

  // ✅ EXTRAER ESTADO CORRECTO DEL INCIDENT (respeta servidor)
  const extractPendingStatus = (incident) => {
    // Si incident trae status explícito, usarlo
    if (typeof incident?.status !== "undefined") {
      return {
        status: incident.status,
        statusText: incident.statusText || "Pendiente",
      };
    }
    // Si hay indicador de rechazo, es "No tomado"
    if (incident?.status === 60 || incident?.classification === "Rechazado") {
      return {
        status: 60,
        statusText: "No tomado",
      };
    }
    // Default: Pendiente
    return { status: 50, statusText: "Pendiente" };
  };

  const handleAssignFromTable = (rowData) => {
    setInitialData(rowData); // 👈 aquí mandas todo el incidente
    setIsModalVisible(true);
  };

  const activeConversation = activeChatId ? conversations[activeChatId] : null;

  const activeIdFolioBodie =
    activeConversation?.idFolioBodie ?? activeConversation?.idHeader;

  const agentActive = activeConversation?.messages?.[0]?.idAgent;

  const formatDate = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = `${d.getMonth() + 1}`.padStart(2, "0");
    const day = `${d.getDate()}`.padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const formatDateStart = (date) => {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d.toISOString();
  };

  const formatDateEnd = (date) => {
    const d = new Date(date);
    d.setHours(23, 59, 59, 999);
    return d.toISOString();
  };

  const getMessageUniqueId = (message) => {
    const candidates = [
      message?._id,
      message?.id,
      message?.messageSid,
      message?.sid,
      message?.data?._id,
      message?.data?.messageSid,
    ];

    return (
      candidates.find(
        (value) => value !== undefined && value !== null && value !== "",
      ) || null
    );
  };

  const normalizeMessage = (message, fallbackAgentId, fallbackFolioId) => {
    const messageId = getMessageUniqueId(message);
    const messageSid = message?.messageSid || message?.sid || messageId;
    const rawStatus = message?.status || "sent";
    const normalizedStatus = String(rawStatus).trim().toLowerCase();

    return {
      id:
        messageId || messageSid || `${fallbackFolioId || "msg"}-${Date.now()}`,
      messageSid:
        messageSid || messageId || `${fallbackFolioId || "msg"}-${Date.now()}`,
      text: message?.msg || message?.text || "",
      type: message?.type || "text",
      class: message?.class || "text",
      idAgent: message?.idAgent || fallbackAgentId,
      idFolioBodie: message?.idFolioBodie || fallbackFolioId,
      dataSend:
        message?.dateSend || message?.dataSend || new Date().toISOString(),
      status: normalizedStatus === "failed" ? "error" : normalizedStatus,
    };
  };

  const mergeConversationMessages = (
    existingMessages = [],
    incomingMessages = [],
  ) => {
    const mergedMessages = [];
    const seenKeys = new Set();

    const addMessage = (message) => {
      const normalized = normalizeMessage(
        message,
        message?.idAgent,
        message?.idFolioBodie,
      );
      const key = normalized.messageSid || normalized.id;

      if (!key || seenKeys.has(key)) {
        return;
      }

      seenKeys.add(key);
      mergedMessages.push(normalized);
    };

    existingMessages.forEach(addMessage);
    incomingMessages.forEach(addMessage);

    return mergedMessages;
  };

  const formattedStart = formatDateStart(startDate);
  const formattedEnd = formatDateEnd(endDate);

  // Usar las regiones del supervisor desde el payload
  const currentRegionId = useMemo(() => {
    return payload?.regionIds;
  }, [payload?.regionIds]);

  const fetchContactsCabin = async () => {
    const supervisorId = payload?._id;
    if (!supervisorId) return;

    try {
      const response = await getContactsCabin({ idSupervisor: supervisorId });
      const contacts = response?.data || [];
      //console.log("getContacts", response);
      const formattedChats = contacts
        .map((item) => {
          const agent = item?._idHeader?.agent;
          if (!agent?._id) return null;

          return {
            id: item._id, // Usamos item._id como ID único del chat (idFolioBodie)
            idAgent: agent._id,
            name: agent.profile?.name || "Sin nombre",
            user: agent.profile?.code,
            profile: agent.profile,
            idHeader: item._idHeader?._id,
            idFolioBodie: item._id,
            type: item.type,
          };
        })
        .filter(Boolean);
      //console.log("getChats formateado", formattedChats);
      setChats(formattedChats);

      // después de setChats(formattedChats)
      setConversations((prev) => {
        const next = {};

        formattedChats.forEach((chat) => {
          next[chat.idFolioBodie] = {
            idHeader: chat.idHeader,
            idFolioBodie: chat.idFolioBodie ?? null,
            type: chat.type,
            idAgent: chat.idAgent,
            // conserva mensajes SOLO si el folio coincide (mismo incidente)
            messages:
              prev[chat.idFolioBodie]?.idFolioBodie === chat.idFolioBodie
                ? prev[chat.idFolioBodie].messages
                : [],
            // conserva el estado de whatsapp abierto/cerrado si coincide el folio
            isWhatsAppOpen:
              prev[chat.idFolioBodie]?.idFolioBodie === chat.idFolioBodie
                ? prev[chat.idFolioBodie].isWhatsAppOpen
                : undefined,
            // conserva el número telefónico
            phone:
              prev[chat.idFolioBodie]?.idFolioBodie === chat.idFolioBodie
                ? prev[chat.idFolioBodie].phone
                : undefined,
          };
        });

        return next;
      });

      return formattedChats;
    } catch (err) {
      console.error("❌ getContactsCabin error:", err);
    }
  };

  useEffect(() => {
    fetchContactsCabin();
  }, [payload?._id]);

  useEffect(() => {
    if (showAlert || showAlertError) {
      setTimeout(() => {
        alertContainerRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 120);
    }
  }, [showAlert, showAlertError]);

  const handleSelectChat = async (idFolioBodie) => {
    setActiveChatId(idFolioBodie);

    const conversation = conversations[idFolioBodie];
    if (!conversation?.idFolioBodie) return;

    // Consultamos si el chat de whatsapp está activo siempre al seleccionar, solo para WhatsApp
    if (conversation.type === "_WHATSAPP_ADJUSTER_") {
      getWhatsAppWindow(conversation.idAgent)
        .then((avaiblechatinput) => {
          const isOpen = avaiblechatinput?.isOpen !== false;
          if (isOpen === false) {
            console.log("No disponible el chat");
          } else {
            console.log("Input chat disponible");
          }
          setConversations((prev) => {
            if (!prev[idFolioBodie]) return prev;
            return {
              ...prev,
              [idFolioBodie]: {
                ...prev[idFolioBodie],
                isWhatsAppOpen: isOpen,
              },
            };
          });
        })
        .catch((err) => {
          console.error("Error getWhatsAppWindow:", err);
        });
    }

    if (conversation.messages?.length > 0) {
      setChatCabin(true);
      return;
    }

    try {
      const response = await getConversationCabin({
        idFolioBodie: conversation.idFolioBodie,
        typeConversation: conversation.type,
        isCabin: true,
      });

      const data = response?.data;
      if (!data) return;
      const messages = data.message || [];
      const phone = data?.phone || "";

      if (phone) {
        setChats((prev) =>
          prev.map((chat) => {
            if (chat.id === idFolioBodie) {
              return {
                ...chat,
                phone,
                user: phone,
              };
            }
            return chat;
          }),
        );
      }

      setConversations((prev) => {
        const prevMessages = prev[idFolioBodie]?.messages || [];
        const normalizedMessages = messages.map((msg) =>
          normalizeMessage(msg, conversation.idAgent, data._id),
        );

        return {
          ...prev,
          [idFolioBodie]: {
            ...prev[idFolioBodie],
            idHeader: conversation.idHeader,
            idFolioBodie: data._id,
            type: conversation.type,
            idAgent: conversation.idAgent,
            user: conversation.user || phone || "",
            phone: phone,
            messages: mergeConversationMessages(
              prevMessages,
              normalizedMessages,
            ),
          },
        };
      });

      setChatCabin(true);
    } catch (err) {
      console.error("❌ getConversationCabin error:", err);
    }
  };

  const handleChange = (value) => {
    //selecciona el id del agente
    setSelectedAgent(value);
  };

  const handleChangeList = (event) => {
    //selecciona el id de la lista
    setSelectedList(event.target.value);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
    setInitialData(null);
  };

  const handleModal = () => {
    setIsModalVisible(true);
  };

  const handleCabin = () => {
    setChatCabin(true);
  };

  const updateMessageStatus = (messageSid, status) => {
    const normalizedStatus = String(status || "")
      .trim()
      .toLowerCase();
    const finalStatus =
      normalizedStatus === "failed" ? "error" : normalizedStatus;
    const target = String(messageSid || "")
      .toLowerCase()
      .trim();

    setConversations((prev) => {
      let updated = false;
      const next = Object.keys(prev).reduce((acc, chatId) => {
        const conversation = prev[chatId];
        if (!conversation || !Array.isArray(conversation.messages)) {
          acc[chatId] = conversation;
          return acc;
        }

        const newMessages = conversation.messages.map((msg) => {
          const candidates = [
            msg.messageSid,
            msg.sid,
            msg._id,
            msg.id,
            msg.data?.messageSid,
            msg.data?._id,
          ]
            .filter(Boolean)
            .map((v) => String(v).toLowerCase().trim());

          const matched = candidates.some(
            (c) => c === target || c.includes(target) || target.includes(c),
          );

          if (matched) {
            updated = true;
            return { ...msg, status: finalStatus };
          }
          return msg;
        });

        acc[chatId] = { ...conversation, messages: newMessages };
        return acc;
      }, {});

      return updated ? next : prev;
    });
  };

  const handleSendMessage = async () => {
    if (!messageValue.trim() || !activeChatId) return;

    const conversation = conversations?.[activeChatId];
    const idFolioBodie = conversation?.idFolioBodie;
    console.log("SE ENVIARA A: ", conversations?.[activeChatId]);

    if (!idFolioBodie) {
      console.warn("No hay idFolioBodie para el chat activo");
      return;
    }

    const activeChat = chats.find((c) => c.id === activeChatId);
    const isWhatsApp =
      activeChat?.type === "_WHATSAPP_ADJUSTER_" ||
      conversation?.type === "_WHATSAPP_ADJUSTER_";

    try {
      let response;
      let enrichedMessage;

      if (isWhatsApp) {
        const recipientPhone = String(
          conversation?.phone || activeChat?.phone || "",
        ).trim();

        if (!recipientPhone) {
          console.warn("No hay phone para enviar el WhatsApp");
          return;
        }

        let toField = recipientPhone;

        if (toField && !toField.startsWith("whatsapp:")) {
          if (toField.startsWith("+")) {
            toField = "whatsapp:" + toField;
          } else {
            toField = "whatsapp:+" + toField;
          }
        }
        console.log("📤 Enviando WhatsApp a:", toField);
        const body = {
          to: toField,
          idFolioBodie,
          idService: payload?.service || payload?.services?.[0] || "",
          body: messageValue.trim(),
        };

        response = await sendWhatsApp(body);

        const messages =
          response?.messages ||
          (Array.isArray(response?.data)
            ? response.data
            : response?.data?.messages);
        if (Array.isArray(messages) && messages.length > 0) {
          const lastMsg = messages[messages.length - 1];
          enrichedMessage = {
            id: lastMsg._id,
            _id: lastMsg._id,
            sid: lastMsg.sid || lastMsg.messageSid || lastMsg._id,
            messageSid: lastMsg.messageSid || lastMsg._id,
            text: lastMsg.msg,
            type: lastMsg.type,
            class: lastMsg.class,
            idAgent: payload._id,
            idFolioBodie,
            dataSend: lastMsg.dateSend,
            status: lastMsg.status || "sent",
            data: lastMsg,
          };
        } else {
          enrichedMessage = {
            id:
              response?.data?._id ||
              response?._id ||
              new Date().getTime().toString(),
            _id:
              response?.data?._id ||
              response?._id ||
              new Date().getTime().toString(),
            sid:
              response?.data?.messageSid ||
              response?.messageSid ||
              response?.data?._id ||
              response?._id ||
              new Date().getTime().toString(),
            messageSid:
              response?.data?.messageSid ||
              response?.messageSid ||
              response?.data?._id ||
              response?._id ||
              new Date().getTime().toString(),
            text: messageValue.trim(),
            type: "supervisor-cabin",
            class: "text",
            idAgent: payload._id,
            idFolioBodie,
            dataSend: new Date().toISOString(),
            status: "sent",
            data: response?.data || response,
          };
        }
      } else {
        const body = {
          message: messageValue.trim(),
          idAgent: activeChat?.idAgent || activeChatId,
          idFolioBodie,
        };

        response = await sendMessageCabin(body);

        const messages = response?.messages;
        if (!Array.isArray(messages) || messages.length === 0) return;

        const lastMsg = messages[messages.length - 1];

        enrichedMessage = {
          id: lastMsg._id,
          _id: lastMsg._id,
          sid: lastMsg.sid || lastMsg.messageSid || lastMsg._id,
          messageSid: lastMsg.messageSid || lastMsg._id,
          text: lastMsg.msg,
          type: lastMsg.type,
          class: lastMsg.class,
          idAgent: payload._id,
          idFolioBodie,
          dataSend: lastMsg.dateSend,
          status: lastMsg.status || "sent",
          data: lastMsg,
        };
      }

      setConversations((prev) => {
        const prevMessages = prev[activeChatId]?.messages || [];

        return {
          ...prev,
          [activeChatId]: {
            ...prev[activeChatId],
            messages: mergeConversationMessages(prevMessages, [
              enrichedMessage,
            ]),
          },
        };
      });

      setMessageValue("");
    } catch (error) {
      console.error("Error enviando mensaje", error);
    }
  };

  const handleAppendMessages = (chatId, response) => {
    try {
      const messages =
        Array.isArray(response?.data) && response.data.length
          ? response.data
          : Array.isArray(response?.messages)
            ? response.messages
            : Array.isArray(response?.data?.messages)
              ? response.data.messages
              : [];

      if (!messages || messages.length === 0) return;

      setConversations((prev) => {
        const prevMessages = prev[chatId]?.messages || [];
        const fallbackFolio =
          prev[chatId]?.idFolioBodie || prev[chatId]?.idHeader;

        const enriched = messages.map((m) => ({
          ...(m || {}),
          idAgent: payload?._id,
          idFolioBodie: fallbackFolio,
        }));

        return {
          ...prev,
          [chatId]: {
            ...prev[chatId],
            messages: mergeConversationMessages(prevMessages, enriched),
          },
        };
      });
    } catch (err) {
      console.error("handleAppendMessages error:", err);
    }
  };

  const handleChangeRep = (value) => {
    setTypeReport(value);
    setSelectedOptionRep(value);
    setSelectedAgent(null); // se resetea el selector de agentes
  };

  useEffect(() => {
    if (selectAgents.length > 0) {
      setSelectedAgent("00001");
    }
  }, [selectAgents]);

  useEffect(() => {
    if (!["1", "2", "3"].includes(selectedOptionRep)) return;

    const fetchAgentsOptions = async () => {
      try {
        let agentsArray = [];
        const serviceId = payload?.service || payload?.services?.[0];

        // 🔵 OPCIÓN 1 → REAL TIME
        if (selectedOptionRep === "1") {
          const response = await getAvailableAgents({
            regionIds: payload.regionIds,
            idService: serviceId,
          });

          //const allowedStatus = ["Disponible", "Conectado", "En ruta"];
          const exeptions = ["offline", "Conectado"];

          agentsArray = (
            Array.isArray(response?.agents) ? response.agents : []
          ).filter(
            (a) => !exeptions.includes((a.status || "").toLowerCase().trim()),
          );
        }

        // 🟢 OPCIÓN 2 → RUTAS
        else if (selectedOptionRep === "2") {
          const response = await usersForRegion({
            regionIds: payload.regionIds,
            serviceId,
          });

          agentsArray = (
            Array.isArray(response?.agents) ? response.agents : []
          ).filter((agent) => agent.status !== 10);
          console.log("agentsArray en rutas:", agentsArray);
        }

        // 🟡 OPCIÓN 3 → Check-In
        else if (selectedOptionRep === "3" /*|| selectedOptionRep === "4"*/) {
          const body = {
            regionIds: payload.regionIds,
            serviceId,
          };

          const response = await locationAgents(body);
          agentsArray = Array.isArray(response?.agents) ? response.agents : [];
        }
        
        if (!Array.isArray(agentsArray)) return;

        const simplifiedAgents = agentsArray.map((item) => {
          // 🔵 real time
          if (selectedOptionRep === "1") {
            return {
              _id: item.agent?._id || item.agent?.user,
              name: item.agent?.profile?.alias || item.agent?.user,
              locationDt: item.agent?.locationDt,
            };
          }

          // 🟡 Rutas
          if (selectedOptionRep === "2") {
            return {
              _id: item._id,
              name: item.profile?.alias || item.user, 
            };
          }

          // 🟡 locationAgents
          if (selectedOptionRep === "3") {
            return {
              _id: item.user_id,
              name: item.profile?.alias || item.user,
            };
          }
        });

        const initialOption = {
          _id: "00001",
          name: "Buscar agente...",
        };

        const fullList = [initialOption, ...simplifiedAgents];

        const nameAgents = simplifiedAgents.map((agent) => ({
          _id: agent._id,
          name: agent.name,
          locationDt: agent.locationDt,
        }));

        setNameAgent(nameAgents);
        setSelectAgents(fullList);
        setSelectedAgent(initialOption._id);
      } catch (error) {
        console.error("Error fetching agent options:", error);
      }
    };

    fetchAgentsOptions();
  }, [selectedOptionRep, currentRegionId, payload?.service]);

  const removeFromRoutes = ({ idAgent, user }) => {
    setLocalRoutes((prev) =>
      prev.filter(
        (item) =>
          item?.raw?.agent?._id !== idAgent && item?.raw?.agent?.user !== user,
      ),
    );
  };

  const addToRoutes = (incident) => {
    const agent = incident?.header?.agent || incident?.agent;
    const externalFolio =
      incident?.header?.externalFolio || incident?.externalFolio;
    const idHeader =
      incident?.header?._id || incident?._idHeader || incident?._id;

    const timeVal = incident?.updatedAt || incident?.createdAt;
    let acceptedDate = "-";
    if (timeVal) {
      try {
        const date = new Date(timeVal);
        acceptedDate = date.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        });
      } catch (e) {
        acceptedDate = "-";
      }
    }

    const newItem = {
      id: idHeader, // Guardamos el _idHeader para permitir cancelaciones
      folio:
        externalFolio ||
        incident?.header?.folio ||
        incident?.folio ||
        "Sin folio",
      externalFolio: externalFolio,
      acceptedDate: acceptedDate,
      raw: {
        ...(incident?.header || incident),
        agent,
        externalFolio,
      },
    };

    setLocalRoutes((prev) => {
      const exists = prev.some((item) => item?.raw?.agent?._id === agent?._id);
      return exists ? prev : [...prev, newItem];
    });
  };

  const addToPending = (incident) => {
    const uniqueKey = getUniquePendingKey(incident);

    // ✅ si no hay externalFolio NO insertar
    if (!uniqueKey) {
      console.warn("⚠️ Caso sin externalFolio", incident);
      return;
    }

    const isRejected =
      incident?.classification !== undefined ||
      incident?.status === 60 ||
      incident?.header?.rejectionReason;

    console.log(
      "🚩 addToPending - incident:",
      incident,
      "isRejected:",
      isRejected,
    );
    const status = 60;

    const cls = (incident?.classification || "").toLowerCase();
    const statusText =
      cls.includes("tiempo de espera") || cls.includes("timeout")
        ? "No tomado"
        : "Rechazado";

    const newItem = {
      externalFolio: uniqueKey,
      client: incident?.data?.[1] || incident?.client || "Sin cliente",
      status,
      statusText,
      raw: incident,
      _uniqueKey: uniqueKey,
    };

    setLocalPending((prev) => {
      const existingIndex = prev.findIndex(
        (item) => item._uniqueKey === uniqueKey,
      );

      // ✅ YA EXISTE → ACTUALIZAR
      if (existingIndex !== -1) {
        const updated = [...prev];

        updated[existingIndex] = {
          ...updated[existingIndex],
          ...newItem,
        };

        return updated;
      }

      // ✅ NUEVO
      return [...prev, newItem];
    });
  };

  const removeFromPending = (externalFolio) => {
    if (!externalFolio) return;

    setLocalPending((prev) =>
      prev.filter((item) => item.externalFolio !== externalFolio),
    );
  };

  // sockets
  useEffect(() => {
    if (!payload?._id || !currentRegionId) return;

    const handleConnect = () => {
      //console.log("🟢 Socket conectado, emitiendo cabin-connected");
      socketWex.emit("cabin-connected", payload._id, currentRegionId);
    };

    // Si ya está conectado, dispara de una
    if (socketWex.connected) {
      handleConnect();
    }

    // Si no, espera conexión
    socketWex.on("connect", handleConnect);

    return () => {
      socketWex.off("connect", handleConnect);
    };
  }, [payload?._id, currentRegionId]);

  useEffect(() => {
    const handleNewMessageCabin = (data) => {
      console.log("📩 cabin-message-inbound:", data);
      playSound({ sound: "message", count: 1, interval: 2000 });
      const adjuster = data?.dataAdjuster;
      const messages = data?.messages;
      const idFolioBodie = data?.idFolioBodie;

      if (!adjuster?._id || !Array.isArray(messages) || !idFolioBodie) return;

      const idAgent = adjuster._id;

      /* ===== CHAT / CONTACTO ===== */
      const enrichedChat = {
        id: idFolioBodie, // Usamos idFolioBodie como ID único del chat
        idAgent,
        name: adjuster.profile?.name || "Sin nombre",
        user: adjuster.user,
        profile: adjuster.profile,
        type: "_CABIN_",
      };

      setChats((prev) => {
        const exists = prev.some((chat) => chat.id === idFolioBodie);
        if (exists) {
          return prev.map((chat) => {
            if (chat.id === idFolioBodie) {
              return {
                ...chat,
                type: "_CABIN_",
              };
            }
            return chat;
          });
        }
        return [...prev, enrichedChat];
      });

      /* ===== MENSAJES (SIN DUPLICADOS) ===== */
      setConversations((prev) => {
        const prevMessages = prev[idFolioBodie]?.messages || [];
        const normalizedMessages = messages.map((msg) =>
          normalizeMessage(msg, idAgent, idFolioBodie),
        );

        if (normalizedMessages.length === 0) return prev;

        return {
          ...prev,
          [idFolioBodie]: {
            ...prev[idFolioBodie],
            idFolioBodie,
            type: "_CABIN_",
            idAgent,
            messages: mergeConversationMessages(
              prevMessages,
              normalizedMessages,
            ),
          },
        };
      });

      if (activeChatId === idFolioBodie) {
        setChatCabin(true);
      }
    };

    const handleNewMessageWhats = (data) => {
      console.log("📩 new-whatsapp-inbound:", data);
      playSound({ sound: "message", count: 1, interval: 2000 });

      const adjuster = data?.adjusterData;
      const messages = data?.folioBodieMessage;
      const idFolioBodie = data?.folioBodieId;
      const idHeader = data?.folioHeaderId;
      const fromPhone = data?.from;

      if (!adjuster?.id || !Array.isArray(messages) || !idFolioBodie) return;

      const idAgent = adjuster.id;

      /* ===== CHAT / CONTACTO ===== */
      const enrichedChat = {
        id: idFolioBodie, // Usamos idFolioBodie como ID único del chat
        idAgent,
        name: adjuster.profile?.name || "Sin nombre",
        user: fromPhone || adjuster.user || "",
        profile: adjuster.profile,
        idHeader,
        idFolioBodie,
        type: "_WHATSAPP_ADJUSTER_",
      };

      setChats((prev) => {
        const exists = prev.some((chat) => chat.id === idFolioBodie);
        if (exists) {
          return prev.map((chat) => {
            if (chat.id === idFolioBodie) {
              return {
                ...chat,
                idHeader: idHeader || chat.idHeader,
                idFolioBodie: idFolioBodie || chat.idFolioBodie,
                type: "_WHATSAPP_ADJUSTER_",
              };
            }
            return chat;
          });
        }
        return [...prev, enrichedChat];
      });

      /* ===== MENSAJES (SIN DUPLICADOS) ===== */
      setConversations((prev) => {
        const prevMessages = prev[idFolioBodie]?.messages || [];
        const normalizedMessages = messages.map((msg) =>
          normalizeMessage(msg, idAgent, idFolioBodie),
        );

        if (normalizedMessages.length === 0) return prev;

        return {
          ...prev,
          [idFolioBodie]: {
            ...prev[idFolioBodie],
            idHeader: idHeader || prev[idFolioBodie]?.idHeader,
            idFolioBodie,
            type: "_WHATSAPP_ADJUSTER_",
            idAgent,
            user: fromPhone || prev[idFolioBodie]?.user || "",
            phone: fromPhone || prev[idFolioBodie]?.phone || "",
            isWhatsAppOpen: data?.whatsappWindow?.isOpen !== false,
            messages: mergeConversationMessages(
              prevMessages,
              normalizedMessages,
            ),
          },
        };
      });

      if (activeChatId === idFolioBodie) {
        setChatCabin(true);
      }
    };

    const cleanupChatFromIncident = (incident, agentId) => {
      const ids = [
        incident?.idFolioBodie,
        incident?._id,
        incident?.header?._id,
        incident?.header?.idFolioBodie,
        incident?.header?.externalFolio,
        incident?.externalFolio,
      ]
        .filter(Boolean)
        .map((value) => String(value).trim());

      const normalizedAgentId =
        agentId || incident?.header?.agent?._id || incident?.agent?._id;
      const normalizedAgentUser =
        incident?.header?.agent?.user || incident?.agent?.user;

      setChats((prev) =>
        prev.filter((chat) => {
          if (normalizedAgentId && chat.idAgent === normalizedAgentId) {
            return false;
          }
          if (normalizedAgentUser && chat.user === normalizedAgentUser) {
            return false;
          }
          if (ids.some((id) => id === String(chat.id))) {
            return false;
          }
          if (ids.some((id) => id === String(chat.idFolioBodie))) {
            return false;
          }
          if (ids.some((id) => id === String(chat.idHeader))) {
            return false;
          }
          return true;
        }),
      );

      setConversations((prev) => {
        const next = { ...prev };
        Object.keys(next).forEach((key) => {
          const conversation = next[key];
          if (!conversation) return;
          if (normalizedAgentId && conversation.idAgent === normalizedAgentId) {
            delete next[key];
            return;
          }
          if (ids.some((id) => id === String(conversation.idFolioBodie))) {
            delete next[key];
            return;
          }
          if (ids.some((id) => id === String(conversation.idHeader))) {
            delete next[key];
            return;
          }
        });
        return next;
      });

      if (
        activeChatId &&
        (normalizedAgentId === activeChatId ||
          ids.some((id) => id === String(activeChatId)))
      ) {
        setActiveChatId(null);
        setMessageValue("");
        setChatCabin(false);
      }
    };

    const handleReject = (data) => {
      playSound({ sound: "reject" });
      //console.log("🔴 REJECT:", data);
      //PARA TABLAS
      const incident = data?.incident;
      const classification = "Rechazado";

      // ✅ VALIDACIÓN
      if (!incident?.header?.agent?._id) {
        console.warn("⚠️ handleReject: datos incompletos", data);
        return;
      }

      const agentId = incident.header.agent._id;

      // 👉 quitar de ruta
      removeFromRoutes({ idAgent: agentId });
      // 👉 devolver a pendientes (incluye estado del servidor)
      addToPending({ ...incident, classification });
      // 👉 limpiar el chat si el caso no se tomó
      cleanupChatFromIncident(incident, agentId);
      //
      setAdjusterName(data?.incident?.header?.agent.profile?.name ?? "");
      setAdjusterUser(data?.incident?.header?.agent.user ?? "");
      setFolioClassification(data?.classification ?? "");
      setOpenRejectModal(true);
      setIsModalVisible(false);

      setTimeout(() => {
        setOpenRejectModal(false);
        setAdjusterName("");
        setAdjusterUser("");
        setFolioClassification("");
      }, 5000);
    };

    const handleAccept = async (data) => {
      playSound({ sound: "accept" });
      //console.log("🟢 ACCEPT:", data);
      //PARA TABLAS
      const incident = data?.incident || data;
      const agent = incident?.header?.agent || incident?.agent;
      const externalFolio =
        incident?.header?.externalFolio || incident?.externalFolio;

      // VALIDACION
      if (!agent?._id) {
        console.warn("VALIDACION FALLÓ: datos incompletos", data);
        return;
      }

      // mover de pendientes a ruta
      // Intentar remover por externalFolio, si no existe intentar por uniqueKey
      removeFromPending(externalFolio);
      addToRoutes(incident);

      //
      const agentAccepted = agent;
      const idAgent = agentAccepted._id;
      const idHeader =
        incident?.header?._id || incident?._idHeader || incident?._id;

      setAdjusterName(agentAccepted.profile?.name ?? "");
      setAdjusterUser(agentAccepted.user ?? "");
      setOpenAcceptModal(true);

      const formattedChats = await fetchContactsCabin();
      const activeChat = formattedChats?.find((c) => c.idHeader === idHeader);

      if (!chatCabin && activeChat) {
        setActiveChatId(activeChat.id);
        setChatCabin(true);
      } else if (!chatCabin && !activeChat) {
        setActiveChatId(idAgent);
        setChatCabin(true);
      }

      setTimeout(() => {
        setOpenAcceptModal(false);
        setAdjusterName("");
        setAdjusterUser("");
      }, 5000);
    };

    const handleCloseIncident = async (data) => {
      playSound({ sound: "finish" });
      try {
        //console.log("⚫ CLOSE:", data);

        const idAgent = data?.idAgent;
        const user = data?.user;

        if (!idAgent && !user) return;

        // 👉 usar función centralizada
        removeFromRoutes({ idAgent, user });

        setAdjusterName(data?.data?.name ?? "Desconocido");
        setAdjusterUser(user ?? "Desconocido");
        setOpenFinishModal(true);

        await fetchContactsCabin();

        const activeChat = chats.find((c) => c.id === activeChatId);
        const shouldClose =
          activeChat &&
          (activeChat.idAgent === idAgent || activeChat.user === user);

        if (idAgent && shouldClose) {
          setActiveChatId(null);
          setMessageValue("");

          setChats((prev) => prev.filter((c) => c.idAgent !== idAgent));

          setConversations((prev) => {
            const next = { ...prev };
            Object.keys(next).forEach((key) => {
              if (next[key]?.idAgent === idAgent) {
                delete next[key];
              }
            });
            return next;
          });
        }
      } catch (error) {
        console.error("Error al procesar cierre de incidente", error);
      } finally {
        setTimeout(() => {
          setOpenFinishModal(false);
          setAdjusterName("");
          setAdjusterUser("");
        }, 5000);
      }
    };

    const handleTimeOut = (data) => {
      playSound({ sound: "timeout" });
      //console.log("⏱️ TIMEOUT:", data.incident.data[2]);
      // para Tablas
      const classification = "No tomado";
      const incident = data?.incident;

      // ✅ VALIDACIÓN
      if (!incident?.header?.agent?._id) {
        console.warn("⏱️ handleTimeOut: datos incompletos", data);
        return;
      }

      const agentId = incident.header.agent._id;
      removeFromRoutes({ idAgent: agentId });
      addToPending({
        ...incident,
        classification: data?.classification || "Excedio tiempo de espera",
      });
      // 👉 limpiar el chat si el caso no se tomó
      cleanupChatFromIncident(incident, agentId);
      //
      setOpenTimeOutModal(true);
      setAdjusterName(data?.incident?.header?.agent.profile?.name ?? "");
      setAdjusterUser(data?.incident?.header?.agent.user ?? "");
      setFolioClassification("Excedio tiempo de espera");

      setTimeout(() => {
        setOpenTimeOutModal(false);
        setAdjusterName("");
        setAdjusterUser("");
        setFolioClassification("");
      }, 5000);
    };

    const normalizeAgents = (data) => {
      if (Array.isArray(data)) return data;
      if (Array.isArray(data?.agents)) return data.agents;
      return [];
    };
    const handleAgentsConnected = (data) => {
      //console.log("data-adjusters", data);

      const safeData = normalizeAgents(data);

      const listAgents = safeData
        .filter((item) => item.status === "Disponible")
        .map((item) => ({
          label: item.agent.profile?.alias || item.agent?.user || "Sin nombre",
          value: item.agent._id,
          agent: item.agent,
        }));

      const agentsWithDefault = [
        { label: "Buscar ajustador...", value: DEFAULT_AGENT, agent: null },
        ...listAgents,
      ];

      setAdjusters(agentsWithDefault);
    };

    const handleAgentAlreadyTaken = () => {
      setMessageAlertError("Este agente ya fue tomado por otro supervisor");
      setTypeAlertError("warning");
      setShowAlertError(true);

      const body = {
        idService: payload?.service || payload?.services?.[0],
        regionIds: payload.regionIds,
      };
      // Volver a pedir lista actualizada
      socketWex.emit("get-adjusters", body);
    };

    const handleAgentRemoved = (data) => {
      const safeData = normalizeAgents(data);
      handleAgentsConnected(safeData);
    };

    const handleCancel = async (data) => {
      console.log("🚫 cabin-cancel-incidents:", data);
      const idAgent = data?.agentId;
      if (!idAgent) return;

      playSound({ sound: "reject" });

      // 1. Limpiar ajustador de ruta
      removeFromRoutes({ idAgent });

      // 2. Traer contactos actualizados
      const formattedChats = await fetchContactsCabin();

      // 3. Comprobar si el chat del ajustador cancelado está abierto actualmente
      const activeChat = (formattedChats || []).find(
        (c) => c.id === activeChatId,
      );
      const shouldClose = activeChat && activeChat.idAgent === idAgent;

      if (shouldClose) {
        setActiveChatId(null);
        setMessageValue("");
      }

      // 4. Quitar el chat de la lista local
      setChats((prev) => prev.filter((c) => c.idAgent !== idAgent));

      // 5. Quitar la conversación de la cabina
      setConversations((prev) => {
        const next = { ...prev };
        Object.keys(next).forEach((key) => {
          if (next[key]?.idAgent === idAgent) {
            delete next[key];
          }
        });
        return next;
      });
    };
    // mensajes entrantes
    socketWex.on("cabin-message-inbound", handleNewMessageCabin);
    socketWex.on("new-whatsapp-inbound", handleNewMessageWhats);
    //sokcets de notificaciones de incidentes
    socketWex.on("cabin-cancel-incidents", handleCancel);
    socketWex.on("adjuster-reject-incident", handleReject);
    socketWex.on("adjuster-reject-for-timeout", handleTimeOut);
    socketWex.on("adjuster-accept-incident", handleAccept);
    socketWex.on("close-incident", handleCloseIncident);
    //la info de los ajustadores
    socketWex.on("data-adjusters", handleAgentsConnected);
    socketWex.on("agent-already-taken", handleAgentAlreadyTaken);
    socketWex.on("agent-removed", handleAgentRemoved);

    return () => {
      socketWex.off("cabin-message-inbound", handleNewMessageCabin);
      socketWex.off("new-whatsapp-inbound", handleNewMessageWhats);
      socketWex.off("cabin-cancel-incidents", handleCancel);
      socketWex.off("adjuster-reject-for-timeout", handleTimeOut);
      socketWex.off("adjuster-reject-incident", handleReject);
      socketWex.off("adjuster-accept-incident", handleAccept);
      socketWex.off("close-incident", handleCloseIncident);
      socketWex.off("data-adjusters", handleAgentsConnected);
      socketWex.off("agent-already-taken", handleAgentAlreadyTaken);
      socketWex.off("agent-removed", handleAgentRemoved);
    };
  }, [payload?._id, currentRegionId, activeChatId]);

  // Para el mapDisplay
  useEffect(() => {
    const fetchAgent = async () => {
      if (!selectedAgent) {
        setUsers([]);
        return;
      }

      try {
        const serviceId = payload?.service || payload?.services?.[0];

        // 🔵 REAL TIME
        if (selectedOptionRep === "1") {
          const response = await getAvailableAgents({
            regionIds: payload.regionIds,
            idService: serviceId,
          });

          const exeptions = new Set(["offline", "conectado"]);

          const agentsArray = (response?.agents || []).filter(
            (a) => !exeptions.has((a.status || "").toLowerCase().trim()),
          );
          const simplifiedAgents = agentsArray.map((agent) => ({
            id: agent.agent?._id,
            usuario: agent.agent?.user,
            name: agent.agent?.profile?.alias || agent.agent?.user,
            locationDt: agent.agent?.locationDt,
            status: agent.status,
            location: agent.agent.location,
            // date: agent.updatedAt,
          }));

          setUsers(simplifiedAgents);

          return;
        }

        // 🟢 RUTAS (2) y 🟡 CHECK-IN (3)
        if (selectedOptionRep === "2" || selectedOptionRep === "3") {
          // Si es "00001" para rutas o check-in, tal vez no queramos llamar a locationForAgent
          // con ese ID, o el backend lo maneja. Por ahora preservamos el comportamiento para 2 y 3
          // pero permitimos que pase para la opción 1.
          if (selectedAgent === "00001") {
            setUsers([]);
            return;
          }

          const body = {
            regionId: payload.regionIds,
            idAgent: selectedAgent,
            type: selectedOptionRep === "2" ? "route" : "check-in",
            startDate: formattedStart,
            endDate: formattedEnd,
            serviceId,
          };
          console.log("body de rutas/check-in:", body);
          const response = await locationForAgent(body);

          const agentsArray = response?.agents || response?.data || [];

          const simplifiedAgents = agentsArray
            .map((agent) => {
              const userData = agent.user_id || {};

              const id =
                userData._id ||
                (typeof agent.user_id === "string" ? agent.user_id : null);

              return {
                id,
                usuario: userData.user || agent.user || "Desconocido",
                name:
                  userData.profile?.name ||
                  userData.user ||
                  agent.nameUser ||
                  agent.user ||
                  "Desconocido",
                location: agent.location,
                date: agent.dateCheckIn || agent.locationAt || agent.createdAt,
              };
            })
            .filter((a) => a.location);
          console.log("simplifiedAgents", simplifiedAgents);
          setUsers(simplifiedAgents);
        }
      } catch (error) {
        console.log("error", error.message);
        setUsers([]);
      }
    };

    fetchAgent();
  }, [
    selectedOptionRep,
    selectedAgent,
    startDate,
    endDate,
    currentRegionId,
    payload?.service,
  ]);

  // 🟠 HeatMap (4)
 /* useEffect(() => {
    if (selectedOptionRep !== "4") return;

    const fetchHeatmapData = async () => {
      try {
        const serviceId = payload?.service || payload?.services?.[0];
        const body = {
          startDate: formatDate(startDate),
          endDate: formatDate(endDate),
          service: serviceId,
        };
        //Consumo del nuevo endpoint
        //const response = await getIncidentsForHeatmap(body);
        console.log(typeof getIncidentsMapReport, "getIncidentsMapReport");
        const response = await getIncidentsMapReport(body);
        const incidents = response?.data || response || [];
        console.log("HeatMap incidents:", incidents);

        // Mapear para que HeatMap view lo entienda (necesita location o ubicationClient)
        const mappedIncidents = Array.isArray(incidents)
          ? incidents.map((inc) => ({
              ...inc,
              location: inc.location || inc.userLocation || inc.ubicationClient,
              date: inc.createdAt || inc.closeAt,
            }))
          : [];

        setUsers(mappedIncidents);
      } catch (error) {
        console.error("Error fetching heatmap data:", error);
        setUsers([]);
      }
    };

    fetchHeatmapData();
  }, [selectedOptionRep, startDate, endDate, payload?.service]); */

  // 🔹 Callbacks para CabinFormModal
  // Abre el chat de cabina cuando la incidencia se crea desde el mapa
  const openCreatedIncidentChat = async (response, formBody) => {
    try {
      const selectedAdjuster = adjusters.find(
        (a) => a.value === formBody?.idAgent,
      );
      const agentProfile = selectedAdjuster?.agent?.profile || {};
      const agentUser = selectedAdjuster?.agent?.user || "";
      const agentName =
        selectedAdjuster?.label || agentProfile?.name || "Sin nombre";

      const incidentId =
        response?.data?._id ||
        response?.incident?._id ||
        response?.idFolioBodie ||
        response?.data?.idFolioBodie;
      const headerId =
        response?.data?._idHeader ||
        response?.incident?.header?._id ||
        response?.idHeader;

      const chatId = incidentId || formBody?.idAgent;
      const isWhatsApp = formBody?.adjusterWhatsappMessage === true;
      const chatType = isWhatsApp ? "_WHATSAPP_ADJUSTER_" : "_CABIN_";

      const virtualChat = {
        id: chatId,
        idAgent: formBody?.idAgent,
        name: agentName,
        user: agentUser,
        profile: agentProfile,
        idHeader: headerId,
        idFolioBodie: chatId,
        type: chatType,
      };

      setChats((prev) => {
        const exists = prev.some(
          (c) => c.id === chatId || c.idAgent === formBody?.idAgent,
        );
        if (exists) {
          return prev.map((c) =>
            c.id === chatId || c.idAgent === formBody?.idAgent
              ? { ...c, ...virtualChat }
              : c,
          );
        }
        return [virtualChat, ...prev];
      });

      setConversations((prev) => {
        if (prev[chatId]) return prev;
        return {
          ...prev,
          [chatId]: {
            idHeader: headerId,
            idFolioBodie: chatId,
            type: chatType,
            idAgent: formBody?.idAgent,
            messages: [],
          },
        };
      });

      setActiveChatId(chatId);
      setChatCabin(true);
      handleSelectChat(chatId, virtualChat);
      fetchContactsCabin();
    } catch (err) {
      console.error(
        "Error al abrir chat automáticamente despues de crear incidente:",
        err,
      );
    }
  };

  // Se ejecuta tras crear correctamente la incidencia
  const handleFormSuccess = async (message, response, formBody) => {
    // ✅ SI SE REASIGNÓ, REMOVER DE PENDIENTES
    if (initialData?.externalFolio || initialData?._id) {
      const keyToRemove =
        initialData?.externalFolio || 
        initialData?._uniqueKey || 
        getUniquePendingKey(initialData);
      removeFromPending(keyToRemove);
      console.log(
        `✨ Caso reasignado - Removido de pendientes: ${keyToRemove}`,
      );
    }

    setMessageAlert(message);
    setTypeAlert("success");
    setShowAlert(true);

    setTimeout(() => setShowAlert(false), 6000);
    setTimeout(() => setInitialData(null), 100);

    await openCreatedIncidentChat(response, formBody);
  };

  const handleFormError = (message) => {
    setMessageAlertError(message);
    setTypeAlertError("error");
    setShowAlertError(true);

    setTimeout(() => setShowAlertError(false), 6000);
  };

  // Escucha cuando el mapa notifica que se creó una incidencia
  useEffect(() => {
    if (!incidentCreatedMeta) return;

    const { response, formBody } = incidentCreatedMeta;
    if (response?.success === true) {
      openCreatedIncidentChat(response, formBody);
    }
  }, [incidentCreatedMeta, adjusters]);

  // render para tabla
  useEffect(() => {
    const supervisorId = payload?._id;
    if (supervisorId) {
      fetchCabinData(supervisorId);
    }
  }, [payload?._id]);

  return (
    <Stack>
      <Stack mb={4} sx={stylesService.stack}>
        <SelectComponent
          onChange={(e) => {
            handleChangeRep(e.target.value);
          }}
          value={selectedOptionRep || ""}
          valueSelect="_id"
          options={reportType}
          colorLabel="white"
          fontSizeInput="15px"
          label={t("Welcome.text65")}
          textColor="gray"
          backgroundColor="white"
        />

        {selectedOptionRep !== "4" && (
        <AutoCompleteComponent
          onChange={handleChange}
          value={selectedAgent || ""}
          valueKey="_id"
          options={selectAgents}
          label={t("Welcome.text273")}
          colorLabel="white"
          fontSizeInput="15px"
          textColor="gray"
          backgroundColor="white"
        />
        )}
      </Stack>

      {selectedOptionRep === "2" ||
      selectedOptionRep === "3" /* || */
     /* selectedOptionRep === "4" */? (
        <Stack sx={{ width: "100%" }} spacing={4}>
          <Stack sx={{ ...stylesService.stack, width: "70%" }}>
            <Calendario
              startDate={startDate}
              endDate={endDate}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
            />
          </Stack>

          {payload?.profile?.class === "_SUPERVISOR_" && (
            <Stack
              direction="row"
              sx={{
                mt: 4,
                mb: 4, // 👈 aquí está la clave
                width: "100%",
              }}
            >
              <Stack style={{ width: "50%" }}>
                <ButtonComponent
                  label="Levantar nuevo reporte"
                  onClick={handleModal}
                  backgroundColor="#0c4a91ff"
                  color="white"
                  width="100%"
                />
              </Stack>
              <Stack style={{ marginLeft: "1rem", width: "50%" }}>
                <ButtonComponent
                  label="Chat de Cabina"
                  onClick={handleCabin}
                  backgroundColor="#0c4a91ff"
                  color="white"
                  width="100%"
                />
              </Stack>
            </Stack>
          )}

          <Stack mt={12} sx={{ width: "100%" }}>
            <CabinTables
              routes={localRoutes}
              pending={localPending}
              onAssign={handleAssignFromTable}
              canCancel={canCancel}
              requirePin={requirePin}
              canReassign={canReassignIncident}
            />
          </Stack>
        </Stack>
      ) : (
        <Stack sx={{ width: "100%" }} spacing={4}>
          {payload?.profile?.class === "_SUPERVISOR_" && (
            <Stack
              direction="row"
              sx={{
                mt: 4,
                mb: 4, // 👈 aquí está la clave
                width: "100%",
              }}
            >
              <Stack style={{ width: "50%" }}>
                <ButtonComponent
                  label="Levantar nuevo reporte"
                  onClick={handleModal}
                  backgroundColor="#0c4a91ff"
                  color="white"
                  width="100%"
                  disabled={canCreateIncident? false : true}
                />
              </Stack>
              <Stack style={{ marginLeft: "1rem", width: "50%" }}>
                <ButtonComponent
                  label="Chat de Cabina"
                  onClick={handleCabin}
                  backgroundColor="#0c4a91ff"
                  color="white"
                  width="100%"
                />
              </Stack>
            </Stack>
          )}
          <Stack mt={12} sx={{ width: "100%" }}>
            <CabinTables
              routes={localRoutes}
              pending={localPending}
              onAssign={handleAssignFromTable}
              canCancel={canCancel}
              requirePin={requirePin}
              canReassign={canReassignIncident}
            />
          </Stack>
        </Stack>
      )}

      <CabinFormModal
        open={isModalVisible}
        onClose={handleCloseModal}
        adjusters={adjusters}
        payload={payload}
        currentRegionId={currentRegionId}
        formState={formState}
        setFormState={setFormState}
        initialData={initialData}
        createForms={createForms}
        onFormSuccess={handleFormSuccess}
        onFormError={handleFormError}
        alertRef={alertContainerRef}
        idSupervisor={idSupervisor}
        prefillLocation={incidentLocation}
      />

      {chatCabin && (
        <ChatCabin
          key="chat-cabin"
          chats={chats}
          conversations={conversations}
          messageValue={messageValue}
          onMessageChange={setMessageValue}
          onSendMessage={handleSendMessage}
          activeChatId={activeChatId}
          onSelectChat={handleSelectChat}
          onClose={() => setChatCabin(false)}
          serviceId={payload?.service || payload?.services?.[0] || ""}
          onUpdateMessageStatus={updateMessageStatus}
          onAppendMessages={handleAppendMessages}
        />
      )}

      {openAcceptModal && (
        <MuiModal
          title="✅ Estatus del caso ✅"
          width="420px"
          visible={openAcceptModal}
          onClose={() => setOpenAcceptModal(false)}
        >
          <Typography
            style={{
              fontFamily: "Raleway, sans-serif",
              fontSize: "20px",
              color: "#2e7d32",
              fontWeight: 500,
            }}
          >
            {`El ajustador ${adjusterName} con Usuario ${adjusterUser} aceptó la asignación del caso.`}
          </Typography>
        </MuiModal>
      )}
      {openFinishModal && (
        <MuiModal
          title="🏁 Estatus del caso 🏁"
          width="420px"
          visible={openFinishModal}
          onClose={() => setOpenFinishModal(false)}
        >
          <Typography
            style={{
              fontFamily: "Raleway, sans-serif",
              fontSize: "20px",
              color: "#1565c0",
              fontWeight: 500,
            }}
          >
            {`El ajustador ${adjusterName} con Usuario ${adjusterUser} finalizó el caso correctamente.`}
          </Typography>
        </MuiModal>
      )}
      {openRejectModal && (
        <MuiModal
          title="⚠️ Estatus del caso ⚠️"
          width="420px"
          visible={openRejectModal}
          onClose={() => setOpenRejectModal(false)}
        >
          <Typography
            style={{
              fontFamily: "Raleway, sans-serif",
              fontSize: "20px",
              color: "#c62828", // Color para el texto (ej: rojo)
              fontWeight: 500,
            }}
          >
            {`El ajustador ${adjusterName} (usuario: ${adjusterUser}) rechazó la asignación del caso. Motivo: ${folioClassification}.`}
          </Typography>
        </MuiModal>
      )}
      {openTimeOutModal && (
        <MuiModal
          title="⚠️ Estatus del caso ⚠️"
          width="420px"
          visible={openTimeOutModal}
          onClose={() => setOpenTimeOutModal(false)}
        >
          <Typography
            style={{
              fontFamily: "Raleway, sans-serif",
              fontSize: "20px",
              color: "#f7ab54",
              fontWeight: 500,
            }}
          >
            {`El ajustador ${adjusterName} (usuario: ${adjusterUser})  ${folioClassification}.`}
          </Typography>
        </MuiModal>
      )}
    </Stack>
  );
}

export default MapsReports;
